import React, { useState } from 'react'
import CategoryMenu from './CategoryMenu'
import CategoryBlogs from './CategoryBlogs'

export default function Home() {
  
  const [categoryForBlogs, setCategoryForBlogs] = useState("")

  return (
    <>
      <CategoryMenu setCategoryForBlogs={setCategoryForBlogs}/>
      {categoryForBlogs != undefined && 
      <CategoryBlogs categoryForBlogs={categoryForBlogs}/>}
    </>
  )
}
